import React from "react";
import style from "./dressingAppearance.module.scss";
import { signedLockedAccess } from "../../../../utils";
import { Form } from "../../../primary";
import { CANCEL_BTN, SAVE_BTN } from "../../../../constants";
import { PERMISSIONS } from "../../../../constants/permissions";
import { FormActions } from "../../../secondary/FormActions/FormActions";
import { ChipGroup } from "../../../secondary/ChipGroup/ChipGroup";
import { Controller } from "react-hook-form";

export const DressingAppearanceEditMode = ({
  assessmentDetails,
  setFormChangesConfirm,
  handleSubmit,
  doSubmit,
  listResp,
  resp,
  control,
  onCancelClick,
  isReadOnly,
}) => (
  <div>
    <Form
      setFormChangesConfirm={setFormChangesConfirm}
      onSubmit={handleSubmit(doSubmit)}
      requiredPermission={PERMISSIONS.TREATMENT}
      disabled={!signedLockedAccess(assessmentDetails?.assessmentStage)}
    >
      <section className={style.form_section}>
        <div className={style.form_section_body}>
          <div className={style.form_field} data-testid={`dressinghStatus`}>
            <div className={style.form_field_label}>
              <span>Dressing Appearance:</span>
            </div>
            <div className={style.form_field_control}>
              <Controller
                name="dressinghStatus"
                control={control}
                defaultValue={resp?.dressingAppearance ?? ""}
                render={({ onChange, onBlur, value }) => (
                  <ChipGroup name="dressinghStatus" options={listResp} value={value} onChange={onChange} onBlur={onBlur} disabled={isReadOnly} />
                )}
              />
            </div>
          </div>
        </div>
      </section>

      <FormActions
        primaryLabel={SAVE_BTN}
        primaryId="updateBtn"
        primaryType="submit"
        primaryDisabled={isReadOnly}
        secondaryLabel={CANCEL_BTN}
        secondaryId="cancel"
        secondaryDisabled={isReadOnly}
        onSecondaryClick={onCancelClick}
      />
    </Form>
  </div>
);
